










































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { User } from '@/data/models/user.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { date2Num, dateEndofDay, dateStartofDay, newDate } from '@/data/utils/helper';
import { UserStatsRequest } from '@/data/models/userstats.model';
import { CampaignCall } from '@/data/models/campaign.model';

@Component
export default class DettaglioChiamateOperatore extends Vue {
	@Prop() operatore!: User;
	@Prop({ default: false }) daily!: boolean;
	@Prop() request!: UserStatsRequest;

	@Inject('CrudService') crudService!: CrudService<CampaignCall>;

	rows: CampaignCall[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('campaigncall');
	startdate!: Date;
	stopdate!: Date;

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	beforeMount() {
		this.initDateFilters();
		this.search();
	}

	initDateFilters() {
		const today = newDate();
		this.startdate = this.request.startdate && !this.daily ? this.request.startdate : today; 
		this.stopdate = this.request.stopdate && !this.daily ? this.request.stopdate : today; 
	}

	search() {
		this.advancedSearch.addSimpleFilter('operatorid', this.operatore.id);
		this.advancedSearch.addRangeFilter('calldate', date2Num(dateStartofDay(this.startdate))!, date2Num(dateEndofDay(this.stopdate))!);
		this.load();
	}

	load() {

		const datareq = this.crudService.searchEntities(
			CampaignCall,
			'campaigncall',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			CampaignCall,
			'campaigncall',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.load();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.load();
	}

}
